import { render, staticRenderFns } from "./zyjzg.vue?vue&type=template&id=10f12532&scoped=true"
import script from "./zyjzg.vue?vue&type=script&lang=js"
export * from "./zyjzg.vue?vue&type=script&lang=js"
import style0 from "./zyjzg.vue?vue&type=style&index=0&id=10f12532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f12532",
  null
  
)

export default component.exports